import { NNA_REQUESTED, NNA_SUCCESS, NNA_ERROR } from './NNAWidget-Actions';

const initialState = {
  data: [],
  isLoading: true,
  isError: false,
  error: null,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case NNA_REQUESTED: {
      return { ...initialState, ...{ data: [], isLoading: true } };
    }

    case NNA_SUCCESS: {
      return { ...initialState, ...{ data: action.payload, isLoading: false } };
    }

    case NNA_ERROR: {
      return { ...initialState, ...{ data: [], isLoading: false, isError: true } };
    }

    default:
      return state;
  }
};

export default Reducer;
